import script from "./ProfileProjectsActiveProjectItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileProjectsActiveProjectItem.vue?vue&type=script&setup=true&lang=js"

import "./ProfileProjectsActiveProjectItem.vue?vue&type=style&index=0&id=5cfdabf2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cfdabf2"]])

export default __exports__